import React from "react";

function ShipToLines({ code, name }) {
  return (
    <span className="pg-cell-ship-to-block">
      <span className="pg-cell-ship-to-code">{code}</span>
      {name ? (
        <small className="pg-cell-ship-to-name">{name}</small>
      ) : null}
    </span>
  );
}

function ShipToCell({ data }) {
  const raw = data?.shipTo;

  if (raw && (raw === "—" || String(raw).startsWith("Mixed"))) {
    if (raw === "—") {
      return (
        <span className="pg-cell-ship-to-block">
          <span className="pg-cell-dim">—</span>
        </span>
      );
    }
    return (
      <span className="pg-cell-ship-to-block">
        <em className="pg-cell-muted">{raw}</em>
      </span>
    );
  }

  if (data?.shipToCode || data?.shipToName) {
    return (
      <ShipToLines code={data.shipToCode || "—"} name={data.shipToName} />
    );
  }

  if (!raw) {
    return (
      <span className="pg-cell-ship-to-block">
        <span className="pg-cell-dim">—</span>
      </span>
    );
  }

  const parts = String(raw).split("\n");
  if (parts.length >= 2) {
    return <ShipToLines code={parts[0]} name={parts.slice(1).join(" ")} />;
  }

  return (
    <span className="pg-cell-ship-to-block">
      <span className="pg-cell-ship-to-code">{raw}</span>
    </span>
  );
}

export default ShipToCell;
